import { Component, OnInit, ViewChild, ɵConsole } from '@angular/core';
import { FormBuilder, Validators, ValidatorFn } from '@angular/forms';
import { Location } from '@angular/common';
import { AlteracaoCadastralClienteService } from './alteracao-cadastral-cliente.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { NotificationsService } from 'angular2-notifications';
import { HttpParams } from '@angular/common/http';
import { DocumentoHelper } from '../../../shared/utils/documento.helper';

@Component({
  selector: 'ngx-alteracao-cadastral-cliente',
  templateUrl: './alteracao-cadastral-cliente.component.html',
  styleUrls: ['./alteracao-cadastral-cliente.component.scss']
})
export class AlteracaoCadastralClienteComponent implements OnInit {

  public formAlterarCadastroCliente = null;
  public cnpjCpf = null;
  public customLogin = null;

  constructor(
    private formBuilder: FormBuilder,
    private service: AlteracaoCadastralClienteService,
    private location: Location,
    private notificationService: NotificationsService,
    private spinnerService: NgxSpinnerService,
  ) { }

  ngOnInit() {

    let resCustom = localStorage.getItem('bway-customLogin');
    this.customLogin = JSON.parse(resCustom)

    this.formAlterarCadastroCliente = this.formBuilder.group({
      cnpjCpf: [null],
      empresaUsuario: [null],
      telefoneComercial: [null],
      email: [null],
    });

  }

  private normalizarCnpjCpfParaBackend(value: any): string | null {
    if (value == null) return null;
    const tipo = DocumentoHelper.detectarTipoDocumento(value);
    return DocumentoHelper.normalizarParaEnvio(value, tipo);
  }

  getCpfCnpjMask(): string {
    return DocumentoHelper.getMascaraCpfCnpj(this.cnpjCpf);
  }

  buscaEstab(data) {

    let params = new HttpParams();

    const valorBruto = this.normalizarCnpjCpfParaBackend(data.cnpjCpf);
    params = params.append('cnpj', valorBruto);
    this.spinnerService.show();

    this.service.buscaCliente(params, (response) => {
      this.spinnerService.hide();
      if (response.totalElements === 0) {
        this.notificationService.warn('CPF/CNPJ não encontrado na base.');
      } else {
        this.formAlterarCadastroCliente.controls['empresaUsuario'].setValue(response.razaoSocial);
        this.formAlterarCadastroCliente.controls['email'].setValue(response.email);
        this.formAlterarCadastroCliente.controls['telefoneComercial'].setValue(response.telefoneComercial);
      }
    }, (error) => {
      this.spinnerService.hide();
      this.notificationService.error(error.message);
      this.limparForm()
    });

  }

  salvarCadastro(data) {

    let params = new HttpParams();

    const valorBruto = this.normalizarCnpjCpfParaBackend(data.cnpjCpf);
    params = params.append('cpfCnpj', valorBruto)

    let register = {

      email: data.email,
      telefoneComercial: data.telefoneComercial

    }

    this.spinnerService.show();

    this.service.updateEnterpriseData(params, register, (response => {
      this.spinnerService.hide();
      this.notificationService.success('Dados cadastral alterado com sucesso.');
      this.limparForm();
    }), error => {

      this.spinnerService.hide();
      this.notificationService.error(error.message);

    });

  }

  limparForm() {

    this.formAlterarCadastroCliente = this.formBuilder.group({
      cnpjCpf: [null],
      empresaUsuario: [null],
      telefoneComercial: [null],
      email: [null],
    });

  }

  previousPage() {

    this.location.back();

  }

  gotoVoltar() {

    this.location.back();

  }

  getButtonPrimaria() {
    if (this.customLogin != null) {
      return this.customLogin.primaria;
    }
  }

  getButtonSecundaria() {
    if (this.customLogin != null) {
      return this.customLogin.secundaria;
    }
  }

  getButtonTerciario() {
    if (this.customLogin != null) {
      return this.customLogin.terciario;
    }
  }

}
